export default {
  labels: {
    google_place: 'Google-Platz',
    live: 'Live',
    setting_up: 'Einrichtung läuft',
  },
  buttons: {
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
    continue_setup: 'Einrichtung fortsetzen',
  },
  delete_confirmation: 'Bist du sicher?',
};
